import { Dependencies } from 'shared/api/common/schemas/templates/adaptedMap'

export const getNestedDependencies = (dependenciesMap: Dependencies, itemId: string): string[] => {
  const result = new Set<string>()

  const getDependencies = (id: string) => {
    const newDependencies = dependenciesMap[id] || []
    for (const dependency of newDependencies) {
      if (result.has(dependency)) {
        continue
      }
      result.add(dependency)
      getDependencies(dependency)
    }
  }

  getDependencies(itemId)

  result.delete(itemId)

  return Array.from(result)
}
